/** @jsxImportSource @emotion/react */
import type { css } from '@emotion/react'

import type { ArticleButtonComponent, LinkUrl } from '@twisto/api-cms'
import { TextButton } from '@twisto/components/atoms/button'

import { getLinkUrl } from 'homepage/utils'

import { button } from './button.styles'

type ButtonProps = {
  styles?: ReturnType<typeof css>
}

export const Button = ({
  background,
  text,
  url,
  article,
  category,
  page,
  styles,
  variant,
}: ArticleButtonComponent & ButtonProps) => {
  const link = getLinkUrl({ url, article, category, page } as LinkUrl)

  if (!link || !text) {
    return null
  }

  return (
    <div css={[button, styles]}>
      <TextButton color={background} href={link} variant={variant ?? 'default'}>
        {text}
      </TextButton>
    </div>
  )
}
